import React from 'react'
import styled from 'styled-components'
import { withBox } from 'components/Box'
import Spinner from 'components/Spinner'

const Wrapper = styled.div`
  margin-top: 8px;
`

const ActivitiesContainer = styled(withBox('div'))`
  padding: 0 4px 16px;

  /*
    Force the autocomplete dropdown (for mentions or emojis) to
    open to the top except for the first 3 comments, to avoid
    showing the dropdown hidden at the bottom of the viewport
   */
  /* stylelint-disable */
  .activity-comment:nth-of-type(n + 4) [class*='__suggestions'] {
    top: auto !important;
  }
  /* stylelint-enable */
`

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  padding: 10px 0 5px 0; /* stylelint-disable-line scales/space */
`

const LoadingMoreActivitiesIndicator = () => (
  <SpinnerContainer>
    <Spinner.Flex
      width={20}
      primary
      style={{
        marginRight: '5px',
        width: '20px',
        position: 'relative',
        top: '-2px',
      }}
    />
  </SpinnerContainer>
)

export { Wrapper, ActivitiesContainer, LoadingMoreActivitiesIndicator }
